(function () {
    const originalFetch = window.fetch;
    const PUBLIC_DOMAIN = window.location.origin;

    // Override fetch to fall back to WP REST API when Funnelback is down
    window.fetch = async function (...args) {
        const urlInput = args[0];
        const requestUrl = (typeof urlInput === 'string') ? urlInput : (urlInput instanceof Request ? urlInput.url : '');

        if (!requestUrl.includes('discover.qld.gov.au') || requestUrl.includes('wp-json')) {
            return originalFetch.apply(this, args);
        }

        try {
            const response = await originalFetch.apply(this, args);
            if (!response.ok) throw new Error('FB Down');
            return response;
        } catch (err) {
            console.warn(`Funnelback Down. Mapping results to ${PUBLIC_DOMAIN}...`);

            let query = '';
            let startRank = 1;
            const perPage = 10;

            try {
                const urlParams = new URLSearchParams(requestUrl.split('?')[1]);
                query = urlParams.get('query') || '';
                startRank = parseInt(urlParams.get('start_rank')) || 1;
            } catch (e) {
                query = ''; 
            }

            try {
                const wpResponse = await originalFetch(`/wp-json/wp/v2/search?search=${encodeURIComponent(query)}`);
                const wpData = await wpResponse.json();
                const paginatedResults = wpData.slice(startRank - 1, startRank - 1 + perPage);

                const fakeData = {
                    question: { query },
                    response: {
                        resultPacket: {
                            query,
                            resultsSummary: {
                                totalMatching: wpData.length,
                                currStart: startRank,
                                currEnd: startRank + paginatedResults.length - 1,
                                numRanks: perPage
                            },
                            results: paginatedResults.map((item, index) => {
                                const rawUrl = item.url || item.link || '';
                                let pageUrl = rawUrl;

                                try {
                                    const tempUrl = new URL(rawUrl);
                                    pageUrl = rawUrl.startsWith(PUBLIC_DOMAIN)
                                        ? rawUrl
                                        : PUBLIC_DOMAIN + tempUrl.pathname;
                                } catch (e) {
                                    pageUrl = rawUrl.replace('https://discover.qld.gov.au', '');
                                }

                                const pageTitle = item.title || 'No Title';

                                return {
                                    rank: startRank + index,
                                    score: 1000 - index,
                                    title: pageTitle,
                                    summary: '',
                                    displayUrl: pageUrl,
                                    liveUrl: pageUrl,
                                    clickTrackingUrl: pageUrl,
                                    indexUrl: pageUrl,
                                    date: null,
                                    fileSize: 0,
                                    fileType: 'html',
                                    listMetadata: { t: [pageTitle], d: [''], u: [pageUrl], s: [''], c: [''] },
                                    metadata: { u: pageUrl }
                                };
                            })
                        },
                        facets: [],
                        curator: { exhibits: [] },
                        exhibits: []
                    }
                };

                return new Response(JSON.stringify(fakeData), {
                    status: 200,
                    headers: { 'Content-Type': 'application/json' }
                });
            } catch (wpErr) {
                console.error('WP Fetch Failed', wpErr);
                return originalFetch.apply(this, args);
            }
        }
    };

    // Fix malformed href attributes caused by URL rewriting
    document.addEventListener('DOMContentLoaded', function () {
        const duplicatePattern = new RegExp(
            `${PUBLIC_DOMAIN.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}https`, 'g'
        );

        const observer = new MutationObserver(() => {
            document.querySelectorAll('a[href]').forEach((link) => {
                link.href = link.href
                    .replace('https://discover.qld.gov.au', '')
                    .replace(duplicatePattern, PUBLIC_DOMAIN)
                    .replace(/^https\/\//, 'https://');
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    });
})();

(function () {
    // --- Config from DOM ---

    const searchForm = document.getElementById('qg-global-search-form');
    const apiUrl = searchForm.getAttribute('api-url');
    const apiSearchUrl = searchForm.getAttribute('api-search-url');
    const apiCollection = searchForm.getAttribute('api-collection');
    const apiProfile = searchForm.getAttribute('api-profile');

    const ct = apiSearchUrl;
    const ut = apiUrl;
    const ht = apiCollection;

    // --- URL parameter parser ---

    function getUrlParams() {
        const t = new URL(window.location.href);
        const e = new URLSearchParams(t.search);
        const sanitise = (v) => (v || '').replace(/[\\#+()$~%*?<>{}]/g, '');
        return {
            query: sanitise((e.get('query') || '').replace(/%2F/g, '/')),
            profile: sanitise(e.get('profile') || ''),
            label: sanitise(e.get('label') || ''),
            filter: sanitise(e.get('filter') || ''),
            startRank: parseInt(e.get('start_rank')) || 1,
            collection: (e.get('collection') || '').replace(/%7E/g, '~'),
            scope: sanitise(e.get('scope') || ''),
            activePage: parseInt(e.get('page')) || 1
        };
    }

    // --- Fetch search results from Funnelback ---

    async function fetchResults(queryString) {
        const response = await fetch(`${ct}?${queryString}`);
        return response.json();
    }

    // --- Render: featured (curator) results ---

    function renderFeaturedResults(exhibits) {
        if (!exhibits.length) return '';

        return `
            <h2 class="search-results-summary">Featured results</h2>
            ${exhibits.map(exhibit => `
                <article class="qg-card qg-card__light-theme qg-card__clickable">
                    <div class="content">
                        <div class="details">
                            <h2 class="qg-card__title">
                                <a href="${ut}${exhibit.linkUrl}" class="stretched-link">${exhibit.titleHtml}</a>
                            </h2>
                            <div class="qg-search-results__results-list">
                                <p class="description">${exhibit.descriptionHtml}</p>
                                <p class="qg-search-results__url">${exhibit.displayUrl}</p>
                            </div>
                        </div>
                    </div>
                </article>
            `).join('')}
        `;
    }

    // --- Render: search result list ---

    function getFileTypeLabel(url) {
        if (!url) return '';
        const ext = url.split('.').pop().toLowerCase();
        const map = {
            pdf: 'PDF', doc: 'DOC', docx: 'DOC',
            xls: 'XLS', xlsx: 'XLS',
            ppt: 'PPT', pptx: 'PPT',
            txt: 'TXT', csv: 'CSV', zip: 'ZIP'
        };
        return map[ext] ? `<span class="search-list ${ext}-icon">${map[ext]}</span>` : '';
    }

    function formatFileSize(size) {
        if (!size || isNaN(size)) return '';
        return `${Math.round(Number(size) / 1024)}kb`;
    }

    function boldTerms(text, query) {
        if (!query) return text;
        const words = query.split(/\s+/).filter(w => w.trim());
        const regex = new RegExp(`(${words.join('|')})`, 'gi');
        return text.replace(regex, (match) => `<strong>${match}</strong>`);
    }

    function renderResults(resultPacket) {
        const { resultsSummary, query, results } = resultPacket;
        const { currStart, currEnd, totalMatching } = resultsSummary;

        const items = results.map(result => {
            const fileTypeLabel = getFileTypeLabel(result.indexUrl);
            const fileSize = formatFileSize(result.fileSize);
            const title = boldTerms(result.title.replace('| Queensland Government', ''), query);
            const description = result.listMetadata?.c ? boldTerms(result.listMetadata.c[0], query) : '';
            const date = result.date
                ? new Date(result.date).toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' })
                : '';

            return `
                <li class="qg-search-results__results-list-item">
                    <h3><a href="${apiUrl + result.clickTrackingUrl}">${title}</a></h3>
                    <ul class="qg-search-results__results-list">
                        <li class="mb-3 text-dark-grey-muted small">${date}</li>
                        <li class="description mb-2">${description}</li>
                        <li class="meta mt-3">
                            ${fileTypeLabel ? `<div>${fileTypeLabel}</div>` : ''}
                            <span class="text-dark-grey-muted small text-break">${result.indexUrl}</span>
                            ${fileSize ? `<span>&nbsp;-&nbsp;${fileSize}</span>` : ''}
                        </li>
                    </ul>
                </li>
            `;
        }).join('');

        return `
            <div id="qg-search-results">
                <h2 class="mb-4">Search results for '${query}'</h2>
                <span class="d-block mb-4">Showing results ${currStart} - ${currEnd} of ${totalMatching}</span>
                <ul class="qg-search-results__results-list">${items}</ul>
            </div>
        `;
    }

    // --- Render: pagination ---

    function renderPagination(resultPacket) {
        const { totalMatching } = resultPacket.resultsSummary; 
        const params = getUrlParams();
        const totalPages = Math.ceil(totalMatching / 10);

        if (totalPages <= 1) return '';

        const baseQuery = `?query=${params.query}&collection=${params.collection}&profile=${apiProfile}&scope=${params.scope}&label=`;

        function handlePageClick(e) {
            e.preventDefault();
            const href = e.currentTarget.href;
            if (!href) return;
            document.querySelector('.qg-site-search__component')?.scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => {
                history.pushState({}, '', href);
                fetchResults(href.split('?')[1]).then(data => {
                    renderPage(data?.response, getUrlParams());
                });
            });
        }

        const pageStart = Math.floor((params.activePage - 1) / 10) * 10 + 1;
        const pageEnd = Math.min(pageStart + 9, totalPages);
        const pages = Array.from({ length: pageEnd - pageStart + 1 }, (_, i) => pageStart + i);

        const prevLink = params.startRank > 1
            ? `<li class="page-item"><a class="page-link" href="${baseQuery}&page=${params.activePage - 1}&start_rank=${params.startRank - 10}"><span aria-hidden="true"></span>Back</a></li>`
            : '';

        const nextLink = totalPages > params.activePage
            ? `<li class="page-item"><a class="page-link" href="${baseQuery}&page=${params.activePage + 1}&start_rank=${params.startRank + 10}">Next<span aria-hidden="true"></span></a></li>`
            : '';

        const pageItems = pages.map(p => {
            const href = `${baseQuery}&page=${p}&start_rank=${10 * (p - 1) + 1}`;
            const active = params.activePage === p ? 'active' : '';
            return `<li class="page-item ${active}"><a class="page-link" href="${href}">${p}</a></li>`;
        }).join('');

        const container = document.createElement('div');
        container.className = 'pagination-container';
        container.innerHTML = `<ul class="pagination">${prevLink}${pageItems}${nextLink}</ul>`;

        // Attach click handlers after creating elements
        container.querySelectorAll('a.page-link').forEach(a => a.addEventListener('click', handlePageClick));

        return container;
    }

    // --- Render: related search tags ---

    function renderRelatedTags(contextualNavigation) {
        const container = document.querySelector('.related-search');
        if (!container) return;

        let nav = container.querySelector('nav.related-navigation');
        if (!nav) {
            nav = document.createElement('nav');
            nav.className = 'related-navigation';
            nav.setAttribute('aria-label', 'Related Searches Navigation');
            container.appendChild(nav);
        }

        let ul = nav.querySelector('ul.tag-list');
        if (!ul) {
            ul = document.createElement('ul');
            ul.className = 'tag-list';
            nav.appendChild(ul);
        }

        ul.innerHTML = '';

        const topicCategory = contextualNavigation?.categories?.find(c => c.name === 'topic');
        const clusters = topicCategory?.clusters || [];

        clusters.forEach(cluster => {
            const sanitisedQuery = cluster.query.replace(/`/g, '');
            const href = `?query=${encodeURIComponent(sanitisedQuery)}&collection=${apiCollection}`;

            const li = document.createElement('li');
            li.className = 'related-search-item';

            const a = document.createElement('a');
            a.href = href;
            a.textContent = sanitisedQuery;
            a.addEventListener('click', (e) => {
                e.preventDefault();
                const searchBox = document.querySelector('.qg-search-site__input');
                if (searchBox) searchBox.value = sanitisedQuery;
                window.location.href = href;
            });

            li.appendChild(a);
            ul.appendChild(li);
        });

        container.style.display = ul.children.length > 0 ? 'block' : 'none';
    }

    // --- Render: full page (results + pagination + related tags) ---

    function renderPage(responseData, urlParams) {
        const resultsContainer = document.getElementById('qg-search-results__container');
        if (!resultsContainer) return;

        if (!responseData?.resultPacket?.resultsSummary?.totalMatching) {
            resultsContainer.innerHTML = `
                <div class="alert alert-warning" role="alert">
                    <h2><i class="fa fa-exclamation-triangle"></i>No results found</h2>
                </div>
            `;
            document.querySelector('.related-tags .tag-list') && (document.querySelector('.related-tags .tag-list').innerHTML = '');
            return;
        }

        const { resultPacket, curator } = responseData;

        resultsContainer.innerHTML = [
            renderFeaturedResults(curator?.exhibits || []),
            renderResults(resultPacket)
        ].join('');

        const pagination = renderPagination(resultPacket);
        if (pagination) resultsContainer.appendChild(pagination);

        renderRelatedTags(resultPacket.contextualNavigation);
    }

    // --- Popular searches & category concierge ---

    function extractLinksFromSection(sectionId) {
        const ul = document.getElementById(sectionId)?.querySelector('ul.list-group');
        if (!ul) return [];
        return Array.from(ul.querySelectorAll('a')).map(a => ({ text: a.textContent.trim(), url: a.href }));
    }

    function populateConcierge() {
        const popularSearches = extractLinksFromSection('popularSearch');
        const categories = extractLinksFromSection('categorySearch');

        function toListItems(items) {
            return items.map(item => `
                <li class="list-group-item searchbox-list-group-item">
                    <a href="${item.url}" tabindex="-1" data-analytics-link-group="qg-global-search-popular-services">
                        ${item.text}
                    </a>
                </li>
            `).join('');
        }

        const popularEl = document.getElementById('dynamic-popular-searches');
        const categoryEl = document.getElementById('dynamic-categories');
        if (popularEl) popularEl.innerHTML = toListItems(popularSearches);
        if (categoryEl) categoryEl.innerHTML = toListItems(categories);
    }

    // --- Render: search form ---

    function renderSearchForm() {
        const params = getUrlParams();
        const formContainer = document.getElementById('qg-search-form');
        if (!formContainer) return;

        formContainer.innerHTML = `
            <form action="#" role="search"
                class="qld__search-form qg-global-web-autocomplete qg-site-search__form qg-site-search__component qg-search-form qg-site-search__multiple-forms"
                data-suggestions="${ut}/s/suggest.json?collection=${ht}&fmt=json%2B%2B&alpha=0.5&profile="
                data-results-url="${ut}/s/search.json?collection=${ht}&profile=&smeta_sfinder_sand=yes">
                <div class="qld__search-form__inner">
                    <label for="qg-search-query-sm" class="qld__label qld__search-form__label u-visually-hidden">
                        Search Queensland Government
                    </label>
                    <input type="text" name="query" id="qg-search-query-sm"
                        class="form-control qg-search-site__input qld__text-input data-hj-allow"
                        autocomplete="off" placeholder="Search website"
                        tabindex="0" aria-required="true" value="${params.query || ''}" />
                    <div class="qld__search-form__btn">
                        <button type="submit" id="qg-site-search__submit"
                            class="qld__btn qld__btn--search asif btn btn-global-primary"
                            title="Search site" data-analytics-link-group="qg-search-page-submit">
                            <span class="qld__btn__icon"></span>
                            <span class="qld__btn__text">Search</span>
                            <i class="fa fa-search fa-rotate-90 d-md-none d-lg-none"></i>
                        </button>
                    </div>
                    <div class="qg-search-concierge qg-search-concierge-initial">
                        <div class="qg-search-concierge-group helper">
                            <div class="qg-search-concierge-content">
                                <h4>Popular searches</h4>
                                <ul class="list-group" id="dynamic-popular-searches"></ul>
                            </div>
                        </div>
                        <div class="qg-search-concierge-group helper">
                            <div class="qg-search-concierge-content">
                                <h4>Browse by category</h4>
                                <ul class="list-group" id="dynamic-categories"></ul>
                            </div>
                        </div>
                    </div>
                    <div class="qg-search-concierge qg-search-concierge-help">
                        <div class="qg-search-concierge-group suggestions"></div>
                        <div class="qg-search-concierge-group highlight hide"></div>
                        <div class="qg-search-concierge-group helper"></div>
                    </div>
                </div>
            </form>
            <p class="my-4">Enter your query in the box above to search.</p>
        `;

        const input = formContainer.querySelector('.qg-search-site__input');
        const conciergeHelp = formContainer.querySelector('.qg-search-concierge-help');
        const submitBtn = formContainer.querySelector('#qg-site-search__submit');

        input?.addEventListener('keydown', (e) => {
            if (conciergeHelp) conciergeHelp.hidden = e.key === 'Enter';
        });

        input?.addEventListener('click', () => {
            if (conciergeHelp) conciergeHelp.hidden = false;
        });

        function handleSearch(e) {
            e.preventDefault();
            const query = input?.value;
            if (!query) {
                document.getElementById('qg-search-results__container').innerHTML = '';
                return;
            }

            const urlParams = new URLSearchParams(window.location.search);
            const current = getUrlParams();
            urlParams.set('scope', current.scope);
            urlParams.set('profile', apiProfile);
            urlParams.set('page', '1');
            urlParams.set('start_rank', '1');
            urlParams.set('collection', ht);

            setTimeout(() => {
                urlParams.set('query', query);
                history.pushState({}, '', '?' + urlParams.toString());
                fetchResults(urlParams.toString()).then(data => {
                    renderPage(data?.response, getUrlParams());
                });
            });
        }

        submitBtn?.addEventListener('click', handleSearch);
    }

    // --- Render: filter sidebar ---

    function renderFilterSidebar() {
        const params = getUrlParams();
        const filterContainer = document.getElementById('qg-filter-by-results');
        if (!filterContainer) return;
        if (!params.filter && (!params.profile || params.profile === 'qld') && !params.scope) return;

        const fcLabel = sessionStorage.getItem('fcLabel');
        const fcProfile = sessionStorage.getItem('fcProfile');
        const fcScope = sessionStorage.getItem('fcScope');

        let labelText = '';
        if (fcLabel) labelText = fcLabel.charAt(0).toUpperCase() + fcLabel.slice(1);
        else if (fcScope) labelText = `Results from <strong>&nbsp;${fcScope}</strong>`;
        else if (fcProfile) labelText = fcProfile.charAt(0).toUpperCase() + fcProfile.slice(1);

        const isQldSelected = sessionStorage.getItem('rcSelectedRadiobutton') === 'qld';

        filterContainer.innerHTML = `
            <div class="qg-filter-by-results">
                <p class="qg-filter-by-results__title">Filter results by</p>
                <form class="form qg-forms-v2 qg-filter-by-results__form">
                    <ol class="questions pt-2">
                        <li>
                            <fieldset>
                                <legend><span class="label">Content type</span></legend>
                                <ol class="choices qg-forms-v2__radio">
                                    <li>
                                        <input checked name="filterBy" id="customOption" type="radio" value="custom"
                                            data-scope="${fcScope}" data-profile="${fcProfile}" data-label="${fcLabel}" />
                                        <label for="customOption">${labelText}</label>
                                    </li>
                                    <li>
                                        <input name="filterBy" id="qld" type="radio" value="qld"
                                            data-profile="qld" data-scope=""
                                            ${isQldSelected ? 'checked' : ''} />
                                        <label for="qld">all Queensland Government</label>
                                    </li>
                                </ol>
                            </fieldset>
                        </li>
                    </ol>
                </form>
                <button type="button" class="qg-btn qg-btn__filter btn-primary mb-2">Apply filters</button>
            </div>
        `;

        filterContainer.querySelectorAll('input[name="filterBy"]').forEach(radio => {
            radio.addEventListener('change', (e) => {
                sessionStorage.setItem('rcSelectedRadiobutton', e.target.value);
            });
        });

        filterContainer.querySelector('.qg-btn__filter')?.addEventListener('click', (e) => {
            e.preventDefault();
            const urlParams = new URLSearchParams(window.location.search);
            const selected = filterContainer.querySelector('input[name="filterBy"]:checked');
            urlParams.set('scope', selected?.getAttribute('data-scope') || '');
            urlParams.set('profile', selected?.getAttribute('data-profile') || '');
            urlParams.set('page', '1');
            urlParams.set('start_rank', '1');
            history.pushState({}, '', '?' + urlParams.toString());
            fetchResults(urlParams.toString()).then(data => {
                renderPage(data?.response, getUrlParams());
            });
        });

        // Auto-apply on load
        filterContainer.querySelector('.qg-btn__filter')?.dispatchEvent(new Event('click'));
    }

    // --- Session storage for filter state ---

    function persistFilterState() {
        const params = getUrlParams();
        if (params.profile && params.profile !== 'qld') {
            sessionStorage.setItem('fcProfile', params.profile);
            sessionStorage.setItem('fcScope', params.scope);
        }
        if (params.label) sessionStorage.setItem('fcLabel', params.label);
    }

    // --- Init ---

    function init() {
        persistFilterState();
        renderFilterSidebar();
        renderSearchForm();

        const params = getUrlParams();
        if (params.query) {
            const spinnerEl = document.querySelector('.qg-search-results__spinner');
            spinnerEl?.removeAttribute('hidden');

            const searchInput = document.querySelector('.qg-site-search__component .qg-search-site__input');
            if (searchInput) searchInput.value = params.query;

            fetchResults(
                `query=${params.query}&collection=${params.collection}&profile=${apiProfile}&scope=${params.scope}&start_rank=${params.startRank}`
            ).then(data => {
                spinnerEl?.setAttribute('hidden', '');
                if (data?.response?.resultPacket?.resultsSummary?.totalMatching > 0) {
                    renderPage(data.response, params);
                } else {
                    document.querySelector('.qg-search-results__spinner')?.remove();
                    renderPage(null, params);
                }
            });
        }
    }

    document.addEventListener('DOMContentLoaded', populateConcierge);
    window.onpopstate = init;
    init();
})();
